import React, {Component} from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import {Transition} from "react-transition-group";
import "./style.scss";

class Modal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        toggle: PropTypes.func,
        width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        position: PropTypes.oneOf(["right", "left", "center", "top", "bottom"]),
        closeIcon: PropTypes.bool,
        backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["static"])]),
        className: PropTypes.string,
    };

    static defaultProps = {
        isOpen: false,
        width: "100%",
        height: "100vh",
        position: "right",
        closeIcon: true,
        backdrop: true,
    };

    render() {
        const {isOpen, toggle, width, height, position, closeIcon, backdrop, children, className} = this.props;

        const transitionStyles = {
            entering: {
                transform:
                    position === 'right' ? 'translateX(100%)' :
                        position === 'bottom' ? 'translateY(100%)' :
                            'scale(0.9)',
                opacity: 0
            },
            entered: {
                transform: 'translate(0, 0) scale(1)',
                opacity: 1,
                transition: 'all 150ms ease-out'
            },
            exiting: {
                transform:
                    position === 'right' ? 'translateX(100%)' :
                        position === 'bottom' ? 'translateY(100%)' :
                            'scale(0.9)',
                opacity: 0,
                transition: 'all 150ms ease-in'
            },
        };

        return (
            <Transition in={isOpen} timeout={200} unmountOnExit>
                {(state) => (
                    <div className={cx("usb-modal-root", `usb-pos-${position}`, className)}>
                        
                        <div
                            className="usb-modal-root__backdrop"
                            onClick={() => backdrop === true && toggle()}
                        />

                        <div
                            className="usb-modal-root__container"
                            style={{
                                width: width,
                                height: height,
                                ...transitionStyles[state]
                            }}
                        >
                            <div className="usb-modal-root__body">
                                {children}
                            </div>
                        </div>
                    </div>
                )}
            </Transition>
        );
    }
}

export default Modal;
